import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "" }
const _hoisted_2 = {
  key: 0,
  class: "lg:space-y-0 lg:flex lg:flex-wrap lg:justify-center lg:gap-4 lg:max-w-full"
}
const _hoisted_3 = {
  key: 1,
  class: "my-12 space-y-6 sm:space-y-0 sm:grid sm:grid-cols-2 sm:gap-x-6 sm:gap-y-12 lg:grid-cols-3 lg:gap-x-8"
}

import PlanSelectorProduct from './PlanSelectorProduct.vue';
import PlanSelectorProduct2 from './PlanSelectorProduct2.vue';
import HispPlanSelectorProduct from './HispPlanSelectorProduct.vue';
import { computed } from 'vue';
import { injectStrict } from '@/plugins/vueServiceContainerPlugin';
import { BrandServiceInterface } from '@/services/brand/brandServiceInterface';
import store from '@/store';
import { Brand } from '../../services/integration/enums';

type Product = {
  id: string,
  name: string,
  description: string,
  download: number | null,
  upload: number | null,
  typicalEveningSpeed: number | null,
  price: number,
  img?: string,
  imghover?: string
}


export default /*@__PURE__*/_defineComponent({
  __name: 'PlanSelector2',
  props: {
    canSelectProduct: { type: Boolean },
    products: {},
    selected: {}
  },
  emits: ["onPlanSelected"],
  setup(__props: any, { emit: __emit }) {

const brandService = injectStrict<BrandServiceInterface>('BrandServiceInterface');

// Computed properties.
const serviceQualification = computed(() => {
  // Get SQ from store.
  return store.state.serviceQualification;
});

const planSelectorProductInformation = brandService.getPlanSelectorProductInformation(serviceQualification.value?.carrier);

const props = __props;

const emit = __emit;

const isSelectedProduct = (product: Product): boolean => {
  return props.canSelectProduct && product.id === props.selected;
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_unref(brandService).getName() === _unref(Brand).HIS)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.products, (product) => {
            return (_openBlock(), _createBlock(HispPlanSelectorProduct, {
              onOnPlanSelected: _cache[0] || (_cache[0] = (id) => emit('onPlanSelected', id)),
              canSelectProduct: _ctx.canSelectProduct,
              product: product,
              key: product.name,
              isSelectedProduct: isSelectedProduct(product),
              planSelectorProductInformation: _unref(planSelectorProductInformation)
            }, null, 8, ["canSelectProduct", "product", "isSelectedProduct", "planSelectorProductInformation"]))
          }), 128))
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_3, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.products, (product) => {
            return (_openBlock(), _createBlock(PlanSelectorProduct2, {
              onOnPlanSelected: _cache[1] || (_cache[1] = (id) => emit('onPlanSelected', id)),
              canSelectProduct: _ctx.canSelectProduct,
              product: product,
              key: product.name,
              isSelectedProduct: isSelectedProduct(product),
              planSelectorProductInformation: _unref(planSelectorProductInformation)
            }, null, 8, ["canSelectProduct", "product", "isSelectedProduct", "planSelectorProductInformation"]))
          }), 128))
        ]))
  ]))
}
}

})